import { apiMethods } from '@services/methods'

import { baseURL } from '@services/common'
import { loadCommerces, setErrorMsg } from './withdrawSlice'

import { BasicToastContent } from '@src/components/basic-toast-content'
import toast from 'react-hot-toast'

const endpoints = {
  withdraw: `${baseURL}/admin/transactions/withdraw`,
  loadCommerces: `${baseURL}/admin/commerce/concession/toll-commerces`
}

const loadCommerce = async () => {
  const response = await apiMethods.authGet({
    url: endpoints.loadCommerces
  })

  const getAmount = (amountsArray) => {
    return amountsArray.find((amount) => amount.currency === 'BS')
  }

  console.log(response.res)
  const commercesAssociated = response.res.data.toll_commerces.map(
    (commerce) => {
      return {
        ...commerce,
        funds: getAmount(commerce.amounts)
      }
    }
  )
  return commercesAssociated
}

export const loadCommercesRequest = () => {
  return async (dispatch) => {
    const commerce = await loadCommerce()
    dispatch(loadCommerces(commerce))
  }
}
export const withdrawCommerce = (body) => {
  return async (dispatch) => {
    const response = await apiMethods.authPost({
      url: endpoints.withdraw,
      body
    })

    if (response.ok) {
      toast((t) => (
        <BasicToastContent
          t={t}
          message={'Retiro exitoso de fondos'}
          type={'success'}
        />
      ))
    } else {
      toast((t) => (
        <BasicToastContent
          t={t}
          message={'Ocurrió un error al retirar los fondos'}
          type={'danger'}
        />
      ))
    }

    const commerce = await loadCommerce()
    dispatch(loadCommerces(commerce))
  }
}

export const cleanError = () => {
  return async (dispatch) => {
    dispatch(setErrorMsg(null))
  }
}
